import { ChangeDetectorRef, Component, Input, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Consultant } from 'src/app/models/consultant.model';
import { FeeBasisAdjustment } from 'src/app/models/fee-basis-adjustment.model';
import { Order } from 'src/app/models/order.model';
import { ConsultantService } from 'src/app/services/consultant.service';
import { FeeBasisAdjustmentService } from 'src/app/services/fee-basis-adjustment.service';

@Component({
    selector: 'app-pivot-view-table',
    templateUrl: './pivot-view-table.component.html',
    styleUrls: ['./pivot-view-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PivotViewTableComponent {
  loading = true;
  reportData: any;
  @Input() set dataSource(value: Order[]) {
    this.reportData = value;
    this._dataSource = new MatTableDataSource<Order>(value);
    this._dataSource.sortingDataAccessor = (data, sortHeaderId) => {
      switch (sortHeaderId) {
        case 'projectSum':
          return data.projectSumExVat;
        case 'pipelineProjectSum':
          return data.pipelineProjectSumExVat;
        case 'weightedPipelineProjectSum':
          return data.pipelineProjectSumExVat * (data.pipelinePercentForSuccess / 100);
        case 'sales':
          return this.amount(data, "salesRealizators");
        case 'executorAmount':
          return this.amount(data, "executors");
        case 'distribution':
          return this.amount(data, "distribution");
      }
      return data[sortHeaderId];
    };
    this._dataSource.sort = this.sorter;
  }
  @Input() projectType: string;
  @Input() displayedColumns: string[];
  @Input() salesRealizator: string;
  @Input() executor: string;

  consultants: Consultant[];
  _dataSource = new MatTableDataSource<Order>([]);
  @ViewChild(MatSort) sorter: MatSort;

  adjustments: FeeBasisAdjustment[];

  constructor(
    protected consultantsService: ConsultantService,
    protected adjustmentService: FeeBasisAdjustmentService
  ) {

  }

  async ngOnInit(): Promise<void> {
    this.consultants = await this.consultantsService.list();
    this.adjustments = await this.adjustmentService.list();
    this.loading = false;
  }

  async ngAfterViewInit(): Promise<void> {

  }

  consultant(id: string) {
    return this.consultants.find(_ => _.id == id)?.initials;
  }

  amount(order: Order, key: string) {
    const adjustments = this.adjustments?.filter(_ => _.orderId == order.id);

    if (key == "salesRealizators" && this.salesRealizator) {
      return order[key]?.filter(_ => _.consultantId == this.salesRealizator).map(_ => _.amount).reduce((prev, curr) => prev + curr, 0)
        + adjustments.filter(_ => _.consultantId == this.salesRealizator).map(_ => _.salesRealizator).reduce((prev, curr) => prev + curr, 0);
    } else if (key == "executors" && this.executor) {
      if (order.pipelineProjectSumExVat)
        return 0;
      let val = order[key]?.filter(_ => _.consultantId == this.executor).map(_ => _.amount).reduce((prev, curr) => prev + curr, 0);
      let share = val / order.pipelineProjectSumExVat;
      val = order.pipelineProjectSumExVat * (order.pipelinePercentForSuccess / 100) * share;
      val += adjustments.filter(_ => _.consultantId == this.executor).map(_ => _.executor).reduce((prev, curr) => prev + curr, 0);
      return val;
    } else if (key == "distribution") {
      if (this.executor) {

        return order.invoices?.filter(_ => _.distribution?.some(d => d.consultantId == this.executor)).map(
          i => i.distribution.filter(d => d.consultantId == this.executor)?.map(t => t.amount)
            .reduce((prev, curr) => prev + curr, 0)
        ).reduce((prev, curr) => prev + curr, 0);
      } else {
        return order.invoices?.map(
          i => i.distribution?.map(t => t.amount)
            .reduce((prev, curr) => prev + curr, 0)
        ).reduce((prev, curr) => prev + curr, 0);
      }
    }
    let adjustment = 0;
    if (key == "salesRealizators") {
      adjustment = adjustments.filter(_ => _.salesRealizator).map(_ => _.salesRealizator).reduce((prev, curr) => prev + curr, 0);
    } else if (key == "executors") {
      if (order.pipelineProjectSumExVat)
        return 0;
      adjustment = adjustments.filter(_ => _.executor).map(_ => _.executor).reduce((prev, curr) => prev + curr, 0);
    }

    return order[key]?.map(_ => _.amount).reduce((prev, curr) => prev + curr, 0) + adjustment;
  }
}
